import { Directive, ElementRef, HostListener, Renderer2} from '@angular/core';

@Directive({
    selector: '[appRestrictHtmltagchars]',
    standalone: false
})

export class RestrictHtmltagcharactersDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  // Covers typing and pasting alike, since paste also raises an input event.
  @HostListener('input') onInput() {
    const input = this.el.nativeElement;
    const value: string = input.value ?? '';
    const cleanedValue = value.replace(/[<>]/g, '');
    // Only touch the value when something was stripped; the re-dispatched input event then finds nothing to strip, so it does not loop.
    if (cleanedValue === value) {
      return;
    }
    const caret = typeof input.selectionStart === 'number'
      ? Math.max(0, input.selectionStart - (value.length - cleanedValue.length))
      : null;
    this.renderer.setProperty(input, 'value', cleanedValue);
    if (caret !== null) {
      input.setSelectionRange(caret, caret);
    }
    input.dispatchEvent(new Event('input'));
  }
}
